/* Pagina prodotto: cambio foto dalle miniature e prezzo che segue la variante. */
(function () {
  document.querySelectorAll('[data-ap-galleria]').forEach(function (g) {
    var foto = g.querySelector('.ap-pdp__foto img');
    var bottoni = g.querySelectorAll('.ap-pdp__mini-btn'), pronte = {};
    /* la foto grande si scarica solo al tocco della miniatura (appena il dito tocca, prima del rilascio) */
    function prepara(b) { var u = b.dataset.apSrc; if (!u || pronte[u]) return; pronte[u] = new Image(); pronte[u].decoding = 'async'; pronte[u].src = u; }
    bottoni.forEach(function (b) {
      b.addEventListener('pointerdown', function () { prepara(b); });
      b.addEventListener('click', function () {
        if (!foto) return;
        foto.src = b.dataset.apSrc;
        foto.removeAttribute('srcset');
        g.querySelectorAll('.ap-pdp__mini-btn').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });

  function euro(c) {
    var i = Math.floor(c / 100), d = c % 100;
    return i + (d ? ',' + (d < 10 ? '0' + d : d) : '') + ' €';
  }
  document.querySelectorAll('[data-ap-varianti]').forEach(function (sel) {
    var box = sel.closest('.ap-pdp__scheda');
    var p = box && box.querySelector('[data-ap-prezzo]');
    if (!p) return;
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var prezzo = parseInt(o.dataset.prezzo, 10), prima = parseInt(o.dataset.prima, 10);
      p.innerHTML = '<span class="ap-pdp__cifra">' + euro(prezzo) + '</span>' + (prima > prezzo ? '<s>' + euro(prima) + '</s>' : '');
    });
  });

  /* descrizione a due righe: il pulsante compare solo se il testo è tagliato */
  document.querySelectorAll('[data-ap-clamp]').forEach(function (box) {
    var p = box.querySelector('[data-ap-clamp-testo]'), b = box.querySelector('[data-ap-tutto]');
    if (!p || !b) return;
    if (p.scrollHeight > p.clientHeight + 2) b.hidden = false;
    b.addEventListener('click', function () {
      var aperto = box.classList.toggle('is-aperto');
      b.textContent = aperto ? 'Mostra meno' : 'Visualizza tutto';
    });
  });

  /* riga della consegna: cambia in base all'ora e al giorno */
  document.querySelectorAll('[data-ap-consegna]').forEach(function (c) {
    var riga = c.querySelector('[data-ap-consegna-riga]'); if (!riga) return;
    var ora = parseInt(c.dataset.ora, 10) || 15;
    var now = new Date(), g = now.getDay(), h = now.getHours(), t;
    if (g === 0 || g === 6) t = riga.dataset.lunedi;
    else if (h < ora) t = riga.dataset.oggi;
    else if (g === 5) t = riga.dataset.lunedi;
    else t = riga.dataset.domani;
    riga.textContent = (t || '').replace('{ora}', ora);
  });

  /* finestra delle rate */
  document.querySelectorAll('[data-ap-rate-apri]').forEach(function (b) {
    var d = b.parentElement.querySelector('[data-ap-rate-dialog]');
    if (!d) return;
    b.addEventListener('click', function () { d.showModal(); });
    d.querySelector('[data-ap-rate-chiudi]').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });

  /* pallini dello slider "Aggiungi anche" */
  document.querySelectorAll('[data-ap-agg-fila]').forEach(function (fila) {
    var box = fila.parentElement.querySelector('[data-ap-agg-pallini]');
    var items = fila.querySelectorAll('.ap-pdp__agg-item');
    if (!box || items.length < 2) return;
    var dots = [];
    items.forEach(function (it, i) {
      var d = document.createElement('i');
      if (i === 0) d.className = 'on';
      box.appendChild(d); dots.push(d);
    });
    function agg() {
      var max = fila.scrollWidth - fila.clientWidth;
      var idx = max > 0 ? Math.round(fila.scrollLeft / max * (items.length - 1)) : 0;
      dots.forEach(function (d, i) { d.className = i === idx ? 'on' : ''; });
    }
    fila.addEventListener('scroll', agg, { passive: true });
    agg();
  });

  /* il confronto riempie lo spazio sotto la foto una volta sola, al caricamento: le fisarmoniche aperte dopo non lo allungano */
  function pareggiaConfronto() {
    var gal = document.querySelector('.ap-pdp__galleria'), col = document.querySelector('.ap-pdp__colonna'), conf = document.querySelector('.ap-pdp__confronto');
    if (!gal || !col || !conf || window.innerWidth <= 900) { if (conf) conf.style.minHeight = ''; return; }
    conf.style.minHeight = '';
    var diff = col.offsetHeight - gal.offsetHeight;
    if (diff > 0) conf.style.minHeight = (conf.offsetHeight + diff) + 'px';
  }
  if (document.readyState === 'complete') pareggiaConfronto(); else window.addEventListener('load', pareggiaConfronto);
  var tmr; window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(pareggiaConfronto, 150); });
})();
